import { wrapProtectedRoute } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Detail from 'containers/desktop/BaseIngredient/Detail/BaseIngredientDetail';
import New from 'containers/desktop/BaseIngredient/New/BaseIngredientNew';
import Search from 'containers/desktop/BaseIngredient/Search/BaseIngredientSearch';
import PERMISSIONS from 'enums/permissions';

const sharedSearchResources = [
	'allergens',
	'baseIngredientCategories',
	'co2Labels',
	'nutriScoreLabels',
	'seasons',
	'tagList',
];

const searchResources = [...sharedSearchResources, 'baseIngredientRanges'];

const searchResourcesArchived = [...sharedSearchResources, 'baseIngredientRangesArchived'];

const basicResources = [
	'nutrientList',
	'seasons',
	'allergens',
	'tagList',
	'baseIngredientCategories',
	'unitList',
];

const routes = [
	{
		path: '/baseIngredient/detail/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.READBASEINGREDIENT],
		resources: basicResources,
	},
	{
		path: '/baseIngredient/search',
		element: <Search archive={false} />,
		permissions: [PERMISSIONS.READBASEINGREDIENT],
		resources: searchResources,
	},
	{
		path: '/baseIngredient/archive',
		element: <Search archive={true} />,
		permissions: [PERMISSIONS.WRITEBASEINGREDIENT],
		resources: searchResourcesArchived,
	},
	{
		path: '/baseIngredient/copy/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.WRITEBASEINGREDIENT],
		resources: basicResources,
	},
	{
		path: '/baseIngredient/new',
		element: <New />,
		permissions: [PERMISSIONS.WRITEBASEINGREDIENT],
		resources: basicResources,
	},
];

export default [...routes.map(wrapProtectedRoute)];
